import React from 'react';
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import SimpleHeader from "../../../framework/util/forms/SimpleHeader";
import PressPalletIcon from "../PressPalletIcon";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from '@material-ui/core/styles';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import SendIcon from '@material-ui/icons/Send';
import Divider from '@material-ui/core/Divider';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
    },
}));

const PalletSummaryInfo = ({pallet, lastPallet}) => {

    const loadTime = pallet.loadTime.toLocaleString();
    const loadOperator = pallet.loadOperatorInfo.firstName + ' ' + pallet.loadOperatorInfo.lastName;
    const lastJob = pallet.jobs && pallet.jobs.length > 0 ? pallet.jobs[0].jobUniqueId : 'No jobs';
    const totalJobs = pallet.jobCount ? pallet.jobCount : 0;
    const totalSheets = pallet.sheetsWithQuantity ? pallet.sheetsWithQuantity : 0;
    const totalSpreads = pallet.spreadCount ? pallet.spreadCount : 0;
    const lastPalletJobCount = lastPallet?.jobs?.length;
    const lastPalletJob = lastPallet?.jobs && lastPallet.jobs.length > 0 ? lastPallet.jobs[0].jobUniqueId : 'No jobs';
    const lastPalletId = lastPallet?.palletId;
    const lastManifestId = lastPallet?.id;

    const items = [];
    items.push((
        <Grid item xs={6}>
            <ListItemText secondary={pallet.palletId} primary="Pallet Id"/>
        </Grid>
    ));
    items.push((
        <Grid item xs={6}>
            <ListItemText secondary={pallet.id} primary="Manifest Id"/>
        </Grid>
    ));
    items.push((
        <Grid item xs={6}>
            <ListItemText secondary={loadTime} primary="Pallet Load Time"/>
        </Grid>
    ));

    items.push((
        <Grid item xs={6}>
            <ListItemText secondary={loadOperator} primary="Pallet Load Operator"/>
        </Grid>
    ));

    items.push((
        <Grid item xs={6}>
            <ListItemText secondary={totalJobs} primary="Total Jobs In Pallet"/>
        </Grid>
    ));

    items.push((
        <Grid item xs={6}>
            <ListItemText secondary={totalSpreads} primary="Total Spreads"/>
        </Grid>
    ));

    items.push((
        <Grid item xs={12}>
            <ListItemText secondary={lastJob} primary={lastJob ? "Last Job Current Pallet": ""}/>
        </Grid>
    ));


    lastPallet && items.push((
        <Grid item xs={12}>
            <Divider />
        </Grid>
    ));


    lastPallet && items.push((
        <Grid item xs={6}>
            <ListItemText secondary={lastPalletId} primary="Previous Pallet Id"/>
        </Grid>
    ));

    lastPallet && items.push((
        <Grid item xs={6}>
            <ListItemText secondary={lastPalletJobCount} primary="Previous Pallet Job Count"/>
        </Grid>
    ));

    lastPallet && items.push((
        <Grid item xs={12}>
            <ListItemText secondary={lastPalletJob} primary="Previous Pallet Last Job"/>
        </Grid>
    ));



    const classes = useStyles();
    const grid = (
        <div className={classes.root}>
            <Paper className={classes.paper}>
            <Grid container spacing={3} >
                {items}
            </Grid>
            </Paper>
        </div>
    );

    return grid;

}

export default PalletSummaryInfo;